export default function detectTvScreen() {
	return navigator.userAgent.match(/Tizen|SmartTV|SMART-TV|PhilipsTV/i) ? true : false;
}
